export const ACESSO_PORTAL = 'ACESSO_PORTAL';

export const ACESSO_FERRAMENTAS_COLABORADOR_CEI = 'ACESSO_FERRAMENTAS_COLABORADOR_CEI';

/** Grupo público do portal; no BD inclui a permissão {@link ACESSO_PORTAL}. */
export const GRUPO_ACESSO_PUBLICO_PORTAL = 'GRUPO_ACESSO_PUBLICO_PORTAL';

export const GRUPO_COLABORADORES_CEI = 'COLABORADORES_CEI';

/** Permissão de gestão completa de projetos — ADM Master (RN07/RN19). */
export const GESTAO_PROJETOS = 'GESTAO_PROJETOS';

/** Grupo de gestores de projetos (equivalente funcional a GESTAO_PROJETOS). */
export const GESTORES_PROJETOS = 'GESTORES_PROJETOS';

/** Permissão de edição de ações e situação objetivo/meta — Editor (RN08/RN30). */
export const EDITAR_PROJETOS = 'EDITAR_PROJETOS';

/** Grupo de editores de projetos (equivalente funcional a EDITAR_PROJETOS). */
export const EDITORES_PROJETOS = 'EDITORES_PROJETOS';

/** Entidades — usados pela Gestão de Startups (sem *_ESPECIFICA). */
export const VISUALIZAR_TODAS_ENTIDADES = 'VISUALIZAR_TODAS_ENTIDADES';
export const CADASTRAR_ENTIDADES = 'CADASTRAR_ENTIDADES';
export const ADMINISTRAR_TODAS_ENTIDADES = 'ADMINISTRAR_TODAS_ENTIDADES';
export const EXCLUIR_ENTIDADES = 'EXCLUIR_ENTIDADES';
export const ADMINISTRADORES_GERAIS_ENTIDADES = 'ADMINISTRADORES_GERAIS_ENTIDADES';

export const SLUG_RECURSO_PAI_FERRAMENTAS = 'ferramentas';

export const SLUG_RECURSO_PAI_SETORES = 'setores';

export const SLUG_RECURSO_PROJETOS = 'projetos';

export const SLUG_RECURSO_STARTUPS = 'startups';

/** Cards da home: consulta global Acoes_Portal / Metas_portal. */
export const SLUG_RECURSO_ACOES = 'acoes';
export const SLUG_RECURSO_METAS = 'metas';
